{
  "manager": {
    "missingPermissions": {
      "title": "Missing Permissions",
      "noAccess": "You do not have permission to access this page.",
      "contactAdmin": "If you believe this is an error, contact an administrator to request access.",
      "backToDashboard": "Back to Dashboard"
    },
    "roleCreateForm": {
      "nameLabel": "Name *",
      "required": "This field is required.",
      "namePlaceholder": "Enter the name of the role",
      "volunteerRoleLabel": "Role is a volunteer role"
    }
  }
}
